import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  isError: false,
  isNotify: false,
  typeNotify: "",
  isLoading: false,
  callBackRequest: false,
  isOpenModalAddProduct: false,
  isOpenModalDetail: false,
  isOpenModalEdit: false,
  isOpenModalConfirm: false,
  isOpenModalGetLog: false,
  dataLog: [],
  contentConfirm: "",
  idProduct: "",
  isOpenModalAddCategry: false,
  callBackRequestCategory: false,
  dataBasePageOne: [],
  refetchAPI: false,
  detailByID: [],
  data: [],
  total: 0,
  dataCategory: [],
  config: {
    search: "",
    status: 2,
    categoryId: 0,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
};
const StoreSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.typeNotify = "";
      state.isLoading = false;
      state.callBackRequest = false;
      state.isOpenModalAddProduct = false;
      state.isOpenModalDetail = false;
      state.isOpenModalEdit = false;
      state.isOpenModalConfirm = false;
      state.isOpenModalGetLog = false;
      state.dataLog = [];
      state.contentConfirm = "";
      state.idProduct = "";
      state.isOpenModalAddCategry = false;
      state.callBackRequestCategory = false;
      state.detailByID = [];
      state.data = [];
      state.total = 0;
      state.dataCategory = [];
      state.config.search = "";
      state.config.status = 2;
      state.config.categoryId = 0;
      state.config.option.limit = 10;
      state.config.option.offset = 1;
      state.config.option.order = "desc";
    },
    setSearchText: (state, action) => {
      state.config.search = action.payload;
    },
    setStatusProduct: (state, action) => {
      state.config.option.offset = 1;
      state.config.status = action.payload;
    },
    setCategoryId: (state, action) => {
      state.config.categoryId = action.payload;
    },
    setPageProduct: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setOpenDetailProduct: (state, action) => {
      state.isOpenModalDetail = action.payload.isOpen;
      state.idProduct = action.payload.id;
    },
    setOpenEditProduct: (state, action) => {
      state.isOpenModalEdit = action.payload.isOpen;
      state.idProduct = action.payload.id;
    },
    setOpenModalAddProduct: (state, action) => {
      state.isOpenModalAddProduct = action.payload;
    },
    setOpenModalConfirm: (state, action) => {
      state.isOpenModalConfirm = action.payload.isOpen;
      state.contentConfirm = action.payload.content;
      state.idProduct = action.payload.id;
    },
    setOpenModalAddCategory: (state, action) => {
      state.isOpenModalAddCategry = action.payload;
    },
    setOpenModalGetLogStore: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
    resetStatus: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      //add product
      .addCase(createProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        if (!action.status) {
          state.isError = true;
          state.msg = action.payload.message;
          state.isLoading = false;
        }
        if (action.payload === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.isError = false;
          state.msg = "Thêm sản phẩm thành công";
          state.callBackRequest = true;
          state.isOpenModalAddProduct = false;
        }
      })
      .addCase(createProduct.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //edit product
      .addCase(editProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editProduct.fulfilled, (state, action) => {
        if (action.payload === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Sửa thông tin sản phẩm thành công";
          state.callBackRequest = true;
          state.typeNotify = "success";
          state.isOpenModalEdit = false;
        }
      })
      .addCase(editProduct.rejected, (state) => {
        state.isNotify = true;
        state.typeNotify = "error";
        state.msg = "Sửa thông tin sản phẩm thất bại";
        state.isLoading = false;
      })

      // get data product
      .addCase(getAllProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllProduct.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.callBackRequest = false;
      })
      .addCase(getAllProduct.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // delete product
      .addCase(deleteProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.isNotify = true;
        state.callBackRequest = true;
        state.msg = "Xóa sản phẩm thành công";
      })
      .addCase(deleteProduct.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // confirm store status
      .addCase(confirmStoreStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(confirmStoreStatus.fulfilled, (state, action) => {
        state.isNotify = true;
        state.callBackRequest = true;
        state.msg = "Cập nhật thành công";
        state.isOpenModalConfirm = false;
      })
      .addCase(confirmStoreStatus.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // get data detail product
      .addCase(getDetailProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailProduct.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.detailByID = action.payload;
      })
      .addCase(getDetailProduct.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })

      .addCase(addCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.isNotify = true;
        state.isOpenModalAddCategry = false;
        state.msg = "Thêm thành công";
        state.isLoading = false;
        state.callBackRequestCategory = true;
      })
      .addCase(addCategory.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //getLog
      .addCase(getLogProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogProduct.fulfilled, (state, action) => {
        state.dataLog = action.payload;
        state.isOpenModalGetLog = true;
        state.isLoading = false;
      })
      .addCase(getLogProduct.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // add data first page
      .addCase(addFirstPageStore.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addFirstPageStore.fulfilled, (state, action) => {
        state.isLoading = true;
        state.isNotify = true;
        state.msg = "Thêm vào trang 1 thành công";
        state.callBackRequest = true;
      })
      .addCase(addFirstPageStore.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // get data first page
      .addCase(getDataFirstPageStore.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataFirstPageStore.fulfilled, (state, action) => {
        state.dataBasePageOne = action.payload;
        state.isLoading = false;
        state.callBackRequest = false;
      })
      .addCase(getDataFirstPageStore.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // save product pin
      .addCase(updateProductPin.pending, (state) => {
        state.isLoading = true;
        state.callBackRequest = false;
      })
      .addCase(updateProductPin.fulfilled, (state, action) => {
        if (action.payload.status) {
          state.isNotify = true;
          state.msg = "Lưu thay đổi thành công";
          state.isLoading = false;
          state.callBackRequest = true;
        }
      })
      .addCase(updateProductPin.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // delete product pin
      .addCase(deleteProductPin.pending, (state) => {
        state.isLoading = true;
        state.callBackRequest = false;
      })
      .addCase(deleteProductPin.fulfilled, (state, action) => {
        if (action.payload.status) {
          state.isNotify = true;
          state.callBackRequest = true;
          state.msg = "Xóa thành công";
          state.isLoading = false;
        }
      })
      .addCase(deleteProductPin.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      });
  },
});
export default StoreSlice;

export const {
  setCategoryId,
  setStatusProduct,
  setOpenEditProduct,
  setOpenDetailProduct,
  setOpenModalConfirm,
  resetStatus,
  setPageProduct,
  setSearchText,
  setOpenModalAddProduct,
  setOpenModalAddCategory,
  setOpenModalGetLogStore,
  resetState,
} = StoreSlice.actions;

export const createProduct = createAsyncThunk(
  "store/createProduct",
  async (data) => {
    try {
      const res = await instance.post("/product/createProduct", data, {
        headers: {
          "Content-type": "multipart/form-date",
        },
      });
      return res.status;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//edit product
export const editProduct = createAsyncThunk(
  "store/editProduct",
  async (data) => {
    try {
      const res = await instance.put("/product/editProduct", data, {
        headers: {
          "Content-type": "multipart/form-date",
        },
      });
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
//delete Product
export const deleteProduct = createAsyncThunk(
  "store/deleteProduct",
  async (id) => {
    try {
      const res = await instance.delete(`product/deleteProduct/${id}`);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);

export const confirmStoreStatus = createAsyncThunk(
  "store/confirmStoreStaus",
  async (data) => {
    try {
      const res = await instance.put(`/product/changeStatusProduct`, data);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
//get all product
export const getAllProduct = createAsyncThunk(
  "store/getAllProduct",
  async (options) => {
    try {
      const config = options
        ? options
        : {
            search: "",
            status: 2,
            categoryId: 0,
            option: {
              limit: 10,
              offset: 1,
              order: "desc",
            },
          };
      const res = await instance.post("/product/adminPageable", config);
      const result = res.data;

      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getDetailProduct = createAsyncThunk(
  "store/getDetailProduct",
  async (id) => {
    try {
      const res = await instance.get(`/product/getProduct/${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const addCategory = createAsyncThunk(
  "store/addCategory",
  async (data) => {
    try {
      const res = await instance.post(`/category/createCategory`, data);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
//get log product
export const getLogProduct = createAsyncThunk(
  "store/getLogProduct",

  async (id) => {
    try {
      const res = await instance.get(`/productLog/getLog/${id}
      `);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
// add firstpage
export const addFirstPageStore = createAsyncThunk(
  "store/addFirstPageStore",
  async (data) => {
    try {
      const res = await instance.post(`/productPin/addProduct`, data);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
// get data firstpage
export const getDataFirstPageStore = createAsyncThunk(
  "store/getDataFirstPageStore",
  async (data) => {
    try {
      const res = await instance.get(
        `/productPin/getAll?search=${data.search}&status=2`
      );
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
//update product pin
export const updateProductPin = createAsyncThunk(
  "store/updateProductPin",
  async (data) => {
    try {
      const res = await instance.post(`/productPin/saveAll`, data);
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
// delete product pin
export const deleteProductPin = createAsyncThunk(
  "store/deleteProductPin",
  async (id) => {
    try {
      const res = await instance.delete(`/productPin/deleteProduct/${id}`);
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
